// extracted by mini-css-extract-plugin
export default {"content":"ConfirmedDataPreview_content__p0NIc","content_title":"ConfirmedDataPreview_content_title__4ng1M"};